import React from "react";
import { StatusPill, type StatusVariant } from "../../atoms";
import { InlineDetailRow } from "../../molecules";
import type { ConnectionHealth } from "../../../pages/Connectors/api";
import { Card } from "./ConnectionHealthCard.styles";
import type { ConnectionHealthCardProps } from "./ConnectionHealthCard.types";

const healthToVariant = (health: ConnectionHealth): StatusVariant => {
  switch (health) {
    case "healthy":
      return "success";
    case "warning":
      return "warning";
    case "error":
      return "error";
    default:
      return "neutral";
  }
};

/**
 * Health / sync card — top-left of the Connection Detail page (UI-4).
 * Rows are driven by API `sync_details` (see `ConnectionDetail.syncRows`).
 */
export const ConnectionHealthCard: React.FC<ConnectionHealthCardProps> = ({
  rows,
  className,
}) => (
  <Card className={className} aria-label="Connection health">
    {rows.map((row) =>
      row.type === "health" ? (
        <InlineDetailRow
          key={row.fieldKey}
          layout="grid-row"
          label={row.label}
          value={
            <StatusPill variant={healthToVariant(row.health)}>
              {row.healthLabel}
            </StatusPill>
          }
        />
      ) : (
        <InlineDetailRow
          key={row.fieldKey}
          layout="grid-row"
          label={row.label}
          value={row.value}
        />
      ),
    )}
  </Card>
);

export default ConnectionHealthCard;
